import { AccountancyRepository } from "./accountancy/accountancy.repo";
import { AccountancySendEmailMultiCommandHandler } from "./accountancy/commands/accountancy-send-email-multi.command";
import { AccountancySendEmailSingleCommandHandler } from "./accountancy/commands/accountancy-send-email-single.command";
import { AccountancyEntriesQueryHandler } from "./accountancy/queries/accountancy-entries.query";
import { AccountancyGridQueryHandler } from "./accountancy/queries/accountancy-grid.query";
import { DateIncludedInAccountingQueryHandler } from "./accountancy/queries/date-included-in-accounting.query";
import { AccountancyPeriodDescriptor } from "./accountancy/utils/accountancy-period-descriptor.service";
import { AdjustmentReasonRepository } from "./adjustment-reason/adjustment-reason.repo";
import { AdjustmentReasonSetDefaultCommandHandler } from "./adjustment-reason/commands/adjustment-reason-set-default.command";
import { AdjustmentReasonQueryHandler } from "./adjustment-reason/queries/adjustment-reason.query";
import { BankAccountRepository } from "./bank-account/bank-account.repo";
import { BankAccountQueryHandler } from "./bank-account/queries/bank-account.query";
import { BannerClosedCommandHandler } from "./banner/commands/banner-closed.command";
import { BannerInfoQueryHandler } from "./banner/queries/banner-info.query";
import { CalendarEventsQueryHandler } from "./calendar/queries/calendar-events.query";
import { ClientGroupRepository } from "./client/client-group.repo";
import { ClientRepository } from "./client/client.repo";
import { ClientGroupSetDefaultCommandHandler } from "./client/commands/client-group-set-default.command";
import { ClientsEppExportQueryHandler } from "./client/queries/client-epp-export.query";
import { ClientsExportQueryHandler } from "./client/queries/client-export.query";
import { ClientGridCollectionQueryHandler } from "./client/queries/client-grid.query";
import { ClientGroupCollectionQueryHandler } from "./client/queries/client-group.query";
import { ClientLinksQueryHandler } from "./client/queries/client-links.query,";
import { ClientQLCollectionQueryHandler } from "./client/queries/client-quick-list.query";
import { ClientsWithSamePropertyQueryHandler } from "./client/queries/clients-with-same-property.query";
import { CnCodeQueryHandler } from "./combined-nomenclature/cn-code.query";
import { FavouriteSwitchCommandHandler } from "./common/commands/favourite-switch.command";
import { CacheableQuickListDataSource } from "./common/quick-list/cacheable-quick-list-data-source.service";
import { QuickListDataSourceFactory } from "./common/quick-list/quick-list-data-source-factory.service";
import { QuickListDataSource } from "./common/quick-list/quick-list-data-source.service";
import { CommunityTransactionForPurchaseQueryHandler } from "./community-transaction/queries/community-transaction-for-purchase.query";
import { CommunityTransactionForSaleQueryHandler } from "./community-transaction/queries/community-transaction-for-sale.query";
import { CompanyConfigureCommandHandler } from "./company/commands/company-configure.command";
import { CompanyParametersRepository } from "./company/company-parameters.repo";
import { CompanyRepository } from "./company/company.repo";
import { CompanyConfigUrlsQueryHandler } from "./company/queries/company-config-urls.query";
import { CompanyFeaturesQueryHandler } from "./company/queries/company-features.query";
import { CompanyParametersQueryHandler } from "./company/queries/company-parameters.query";
import { CountrySetDefaultCommandHandler } from "./country/commands/country-set-default.command";
import { CountryRepository } from "./country/country.repo";
import { CountryCollectionQueryHandler } from "./country/queries/country.query";
import { CurrencySetDefaultCommandHandler } from "./currency/commands/currency-set-default.command";
import { CurrencyRepository } from "./currency/currency.repo";
import { CurrencyExchangeRateQueryHandler } from "./currency/queries/currency-exchange-rate.query";
import { CurrencyCollectionQueryHandler } from "./currency/queries/currency.query";
import { DocumentDownloadFileCommandHandler, DocumentDownloadFileMultiCommandHandler } from "./documents/commands/document-download-file.command";
import { DocumentSendEmailMultiCommandHandler, DocumentSendEmailSingleCommandHandler } from "./documents/commands/document-send-email.command";
import { DocumentAdjustmentSummaryQueryHandler } from "./documents/queries/document-adjustment-summary.query";
import { DocumentLinksQueryHandler } from "./documents/queries/document-links.query";
import { EInvoiceReceivedCreateEInvoiceCommandHandler } from "./e-invoice/commands/e-invoice-received-create-e-invoice.command";
import { EInvoiceReceivedDownloadHeadersCommandHandler } from "./e-invoice/commands/e-invoice-received-download-headers.command";
import { EInvoiceReceivedGenerateCollectiveIdentifierHandler } from "./e-invoice/commands/e-invoice-received-generate-collective-identifier.command";
import { EInvoiceReceivedReceiveXmlCommandHandler } from "./e-invoice/commands/e-invoice-received-receive-xml.command";
import { EInvoiceReceivedDownloadHeadersLastSuccessDateQueryHandler } from "./e-invoice/queries/e-invoice-received-download-headers-last-success-date.query";
import { EInvoiceReceivedGetHeaderXmlQueryHandler } from "./e-invoice/queries/e-invoice-received-get-headers-xml.query";
import { EInvoiceReceivedGetKsefHashQueryHandler } from "./e-invoice/queries/e-invoice-received-get-ksef-hash.query";
import { EInvoiceReceivedHeaderValidationResultQueryHandler } from "./e-invoice/queries/e-invoice-received-header-validation-result.query";
import { EInvoiceReceivedCollectionQueryHandler } from "./e-invoice/queries/e-invoice-received.query";
import { EmailStatusDescriptorService } from "./email/email-status-data-provider.service";
import { EventNotificationsService } from "./event-notifications/event-notifications.service";
import { AccountancyEmailStatusesNotificator } from "./event-notifications/notificators/accountancy-email-status-notificator.service";
import { AnnouncementsNotificator } from "./event-notifications/notificators/announcement-notificator.service";
import { ClientsImportNotificator } from "./event-notifications/notificators/clients-import-notificator.service";
import { DataExchangeStatusNotificator } from "./event-notifications/notificators/data-exchange-status-notificator.service";
import { DocumentKsefStatusNotificator } from "./event-notifications/notificators/document-ksef-status-notificator.service";
import { InventoryStatusesNotificator } from "./event-notifications/notificators/inventory-statuses-notificator.service";
import { KsefConfigurationStatusNotificator } from "./event-notifications/notificators/ksef-configuration-status-notificator.service";
import { KsefMonitorStatusNotificator } from "./event-notifications/notificators/ksef-monitor-status-notificator.service";
import { PreparingDataNotificator } from "./event-notifications/notificators/preparing-data-notificator.service";
import { ProductsImportNotificator } from "./event-notifications/notificators/products-import-notificator.service";
import { ReminderStatusesNotificator } from "./event-notifications/notificators/reminder-statuses-notificator.service";
import { SaleStatusesNotificator } from "./event-notifications/notificators/sale-statuses-notificator.service";
import { ExpenseRepository } from "./expense/expense.repo";
import { ExpensePagedCollectionQueryHandler } from "./expense/queries/expense.query";
import { FiscalDeviceRegistryCreateEventCommandHandler, FiscalDeviceRegistryUpdateEventCommandHandler } from "./fiscal/commands/fiscal-device-registry-event.command";
import { FiscalDeviceSetDefaultCommandHandler } from "./fiscal/commands/fiscal-device-set-default.command";
import { FiscalDeviceRepository } from "./fiscal/fiscal-device.repo";
import { FiscalDeviceRegistryQueryHandler } from "./fiscal/queries/fiscal-device-registry.query";
import { FiscalDeviceQueryHandler } from "./fiscal/queries/fiscal-device.query";
import { GusDataByTinQueryHandler } from "./gus/queries/gus-data-by-tin.query";
import { ImportRepository } from "./import/import.repo";
import { IntegrationRepository } from "./integrations/integration.repo";
import { AvailableIntegrationsListQueryHandler } from "./integrations/queries/available-integrations-list.query";
import { IntegrationsListQueryHandler } from "./integrations/queries/integrations-list.query";
import { InventoryStocktakingApprovalCommandHandler } from "./inventory/commands/inventory-stocktaking-approval.command";
import { InventoryStocktakingDownloadDocumentCommandHandler } from "./inventory/commands/inventory-stocktaking-download-document.command";
import { InventoryGoodsIssueAdjustmentDocumentRepository } from "./inventory/inventory-goods-issue-adjustment-document.repo";
import { InventoryGoodsIssueDocumentRepository } from "./inventory/inventory-goods-issue-document.repo";
import { InventoryGoodsReceiptAdjustmentDocumentRepository } from "./inventory/inventory-goods-receipt-adjustment-document.repo";
import { InventoryGoodsReceiptDocumentRepository } from "./inventory/inventory-goods-receipt-document.repo";
import { InventoryKindRepository } from "./inventory/inventory-kind.repo";
import { InventoryStocktakingDocumentRepository } from "./inventory/inventory-stocktaking-document.repo";
import { InventoryRepository } from "./inventory/inventory.repo";
import { InventoryDocumentAssociatedWithGoodsIssueQueryHandler } from "./inventory/queries/inventory-document-associated-with-goods-issue.query";
import { InventoryGoodsIssueGridQueryHandler } from "./inventory/queries/inventory-goods-issue-grid.query";
import { InventoryGoodsReceiptGridQueryHandler } from "./inventory/queries/inventory-goods-receipt-grid.query";
import { InventoryKindQueryHandler } from "./inventory/queries/inventory-kind.query";
import { InventoryLevelGridQueryHandler } from "./inventory/queries/inventory-level-grid.query";
import { InventoryMovementReportGridQueryHandler } from "./inventory/queries/inventory-movement-report-grid.query";
import { InventoryStocktakingDocumentLinksQueryHandler } from "./inventory/queries/inventory-stocktaking-document-links.query";
import { InventoryStocktakingGridQueryHandler } from "./inventory/queries/inventory-stocktaking-grid.query";
import { InventoryStocktakingProductRecordsQueryHandler } from "./inventory/queries/inventory-stocktaking-product-records.query";
import { InventoryQueryHandler } from "./inventory/queries/inventory.query";
import { KsefCheckDocumentStatusCommandHandler } from "./ksef/commands/ksef-check-document-status.command";
import { KsefReceiveUpoCommandHandler } from "./ksef/commands/ksef-receive-upo.command";
import { KsefRefreshConfigurationStatusCommandHandler } from "./ksef/commands/ksef-refresh-configuration-status.command";
import { KsefCertificateService } from "./ksef/ksef-certificate.service";
import { KsefSendParametersRepository } from "./ksef/ksef-send-parameters.repo";
import { KsefConfigurationStatusQueryHandler } from "./ksef/queries/ksef-configuration-status.query";
import { KsefEnvironmentQueryHandler } from "./ksef/queries/ksef-environment.query";
import { KsefGetCollectiveIdentifiersByKsefNumberQueryHandler } from "./ksef/queries/ksef-get-collective-identifiers-by-ksef-number.query";
import { KsefGetDocumentXmlQueryHandler, KsefGetDocumentXmlToPreviewQueryHandler } from "./ksef/queries/ksef-get-document-xml.query";
import { KsefGetHashQueryHandler } from "./ksef/queries/ksef-get-hash.query";
import { KsefGetUpoXmlQueryHandler } from "./ksef/queries/ksef-get-upo-xml.query";
import { KsefSendParametersQueryHandler } from "./ksef/queries/ksef-send-parameters.query";
import { KsefSentDocumentErrorsQueryHandler } from "./ksef/queries/ksef-sent-document-errors.query";
import { LaboratoryRefreshInfoCommandHandler } from "./laboratory/commands/laboratory-refresh-info.command";
import { LaboratoryInfoQueryHandler } from "./laboratory/queries/laboratory-info.query";
import { UserLicensesQueryHandler } from "./license/queries/user-license.query";
import { MailTemplateRepository } from "./mail-template/mail-template.repo";
import { MailTemplateQueryHandler } from "./mail-template/queries/mail-template.query";
import { MarginSchemeKindQueryHandler } from "./margin-scheme-kind/queries/margin-scheme-kind.query";
import { AddDashboardNoteCommandHandler } from "./notes/commands/add-dashboard-note.command";
import { DeleteDashboardNoteCommandHandler } from "./notes/commands/delete-dashboard-note.command";
import { UpdateDashboardNoteCommandHandler } from "./notes/commands/update-dashboard-note.command";
import { AllDashboardNotesQueryHandler } from "./notes/queries/all-dashboard-notes.query";
import { NumberingRepository } from "./numbering/numbering.repo";
import { NumberingLinkedWithSalePatternQueryHandler } from "./numbering/queries/numbering-linked-with-sale-pattern.query";
import { NumberingQueryHandler } from "./numbering/queries/numbering.query";
import { OnlineReceiversQueryHandler } from "./online-receivers/online-receivers.query";
import { OrderKindRepository } from "./orders/order-kind.repo";
import { OrdersProviders } from "./orders/orders.providers";
import { OrderKindQueryHandler } from "./orders/queries/order-kind.query";
import { OssVatRateOrderingCommandHandler } from "./oss-vat-rate/oss-vat-rate-ordering.command";
import { OssVatRateSetDefaultCommandHandler } from "./oss-vat-rate/oss-vat-rate-set-default.command";
import { OssVatRateRepository } from "./oss-vat-rate/oss-vat-rate.repo";
import { PaymentMethodBaseQueryHandler } from "./payment-method/queries/payment-method-base.query";
import { PaymentMethodQueryHandler } from "./payment-method/queries/payment-method.query";
import { PkwiuPagedCollectionQueryHandler } from "./pkwiu/pkwiu.query";
import { PrintingPatternConfig } from "./printing-pattern/printing-pattern-config.service";
import { PrintingPatternRepository } from "./printing-pattern/printing-pattern.repo";
import { PrintingPatternQueryHandler } from "./printing-pattern/queries/printing-pattern.query";
import { ProductGroupSetDefaultCommandHandler } from "./product-group/commands/product-group-set-default.command";
import { ProductGroupRepository } from "./product-group/product-group.repo";
import { ProductGroupCollectionQueryHandler } from "./product-group/queries/product-group.query";
import { ProductActivateCommandHandler } from "./product/commands/product-activate.command";
import { ProductsAssociateEInvoiceSymbolCommandHandler } from "./product/commands/product-associate-e-invoice-symbol.command";
import { ProductEnableInventoryControlCommandHandler } from "./product/commands/product-enable-inventory-control.command";
import { ProductRepository } from "./product/product.repo";
import { ProductsEppExportQueryHandler } from "./product/queries/product-epp-export.query";
import { ProductsExportQueryHandler } from "./product/queries/product-export.query";
import { ProductGeneratingSymbolQueryHandler } from "./product/queries/product-generating-symbol.query";
import { ProductGetAssociatedEInvoiceSymbolsQueryHandler } from "./product/queries/product-get-associated-e-invoice-symbols.query";
import { ProductGetIdsByExternalIdsQueryHandler } from "./product/queries/product-get-ids-by-external-ids.query";
import { ProductGridCollectionQueryHandler } from "./product/queries/product-grid.query";
import { ProductInventoryLevelQueryHandler } from "./product/queries/product-inventory-level.query";
import { ProductJpkVatGroupCollectionQueryHandler } from "./product/queries/product-jpk-vat-group.query";
import { ProductOffersQueryHandler } from "./product/queries/product-offers.query";
import { ProductQLCollectionQueryHandler } from "./product/queries/product-quick-list.query";
import { ProductsGetAssociatedEInvoiceSymbolsQueryHandler } from "./product/queries/products-get-associated-e-invoice-symbols.query";
import { ProductsRelatedToSalePatternsQueryHandler } from "./product/queries/products-related-to-sale-patterns.query";
import { ProductsWithSamePropertyQueryHandler } from "./product/queries/products-with-same-property.query";
import { PurchaseExecuteInventoryCostCommandHandler } from "./purchase/commands/purchase-execute-inventory-cost.command";
import { PurchaseEInvoiceDocumentRepository } from "./purchase/purchase-e-invoice-document.repo";
import { PurchaseExpenseDocumentRepository } from "./purchase/purchase-expense-document.repo";
import { PurchaseInvoiceAdjustmentDocumentRepository } from "./purchase/purchase-invoice-adjustment-document.repo";
import { PurchaseInvoiceDocumentRepository } from "./purchase/purchase-invoice-document.repo";
import { PurchaseKindRepository } from "./purchase/purchase-kind.repo";
import { PurchaseDocumentUniqueOriginalNumberQueryHandler } from "./purchase/queries/purchase-document-unique-original-number.query";
import { PurchaseEInvoiceGetConvertedXmlQueryHandler } from "./purchase/queries/purchase-e-invoice-get-converted-xml.query";
import { PurchaseGridQueryHandler } from "./purchase/queries/purchase-grid.query";
import { PurchaseJpkVatGroupCollectionQueryHandler } from "./purchase/queries/purchase-jpk-vat-group.query";
import { PurchaseKindQueryHandler } from "./purchase/queries/purchase-kind.query";
import { PurchaseKsefNumberAlreadyInUseQueryHandler } from "./purchase/queries/purchase-ksef-number-already-in-use.query";
import { BalanceSheetExportQueryHandler } from "./reports/balance-sheet/report-balance-sheet-export.query";
import { BalanceSheetCollectionQueryHandler } from "./reports/balance-sheet/report-balance-sheet-grid.query";
import { BalanceSheetPrintQueryHandler } from "./reports/balance-sheet/report-balance-sheet-print.query";
import { ReportInventoryStocktakingExportQueryHandler } from "./reports/inventory-stocktaking/report-inventory-stocktaking-export.query";
import { ReportInventoryStocktakingGridQueryHandler } from "./reports/inventory-stocktaking/report-inventory-stocktaking-grid.query";
import { ReportInventoryStocktakingPrintQueryHandler } from "./reports/inventory-stocktaking/report-inventory-stocktaking-print.query";
import { PurchaseRegistryExportQueryHandler } from "./reports/purchase-registry/report-purchase-registry-export.query";
import { PurchaseRegistryCollectionQueryHandler } from "./reports/purchase-registry/report-purchase-registry-grid.query";
import { PurchaseRegistryPrintingQueryHandler } from "./reports/purchase-registry/report-purchase-registry-printing.query";
import { PurchasesByPeriodExportQueryHandler } from "./reports/purchases-by-period/report-purchases-by-period-export.query";
import { PurchasesByPeriodCollectionQueryHandler } from "./reports/purchases-by-period/report-purchases-by-period-grid.query";
import { PurchasesByPeriodPrintingQueryHandler } from "./reports/purchases-by-period/report-purchases-by-period-printing.query";
import { ReportExporterService } from "./reports/report-exporter.service";
import { ReportPrinterService } from "./reports/report-printer.service";
import { SaleRegistryExportQueryHandler } from "./reports/sale-registry/report-sale-registry-export.query";
import { SaleRegistryCollectionQueryHandler } from "./reports/sale-registry/report-sale-registry-grid.query";
import { SaleRegistryPrintingQueryHandler } from "./reports/sale-registry/report-sale-registry-printing.query";
import { SalesByClientsExportQueryHandler } from "./reports/sales-by-clients/report-sales-by-clients-export.query";
import { SalesByClientsCollectionQueryHandler } from "./reports/sales-by-clients/report-sales-by-clients-grid.query";
import { SalesByClientsPrintingQueryHandler } from "./reports/sales-by-clients/report-sales-by-clients-printing.query";
import { SalesByPeriodExportQueryHandler } from "./reports/sales-by-period/report-sales-by-period-export.query";
import { SalesByPeriodCollectionQueryHandler } from "./reports/sales-by-period/report-sales-by-period-grid.query";
import { SalesByPeriodPrintingQueryHandler } from "./reports/sales-by-period/report-sales-by-period-printing.query";
import { SalesByProductsExportQueryHandler } from "./reports/sales-by-products/report-sales-by-products-export.query";
import { SalesByProductsCollectionQueryHandler } from "./reports/sales-by-products/report-sales-by-products-grid.query";
import { SalesByProductsPrintingQueryHandler } from "./reports/sales-by-products/report-sales-by-products-printing.query";
import { SalesWstoExportQueryHandler } from "./reports/sales-wsto/report-sales-wsto-export.query";
import { SalesWstoCollectionQueryHandler } from "./reports/sales-wsto/report-sales-wsto-grid.query";
import { SalesWstoPrintingQueryHandler } from "./reports/sales-wsto/report-sales-wsto-printing.query";
import { UnsettledPaymentsExportQueryHandler } from "./reports/unsettled-payments/report-unsettled-payments-export.query";
import { UnsettledPaymentsCollectionQueryHandler } from "./reports/unsettled-payments/report-unsettled-payments-grid.query";
import { UnsettledPaymentsPrintingQueryHandler } from "./reports/unsettled-payments/report-unsettled-payments-printing.query";
import { SaleSaveCollectiveIdentifierCommandHandler } from "./sale/command/sale-save-collective-identifier.command";
import { SaleSendDocumentsToKsefCommandHandler } from "./sale/command/sale-send-documents-to-ksef.command";
import { SaleUpdateFiscalizationStatusCommandHandler } from "./sale/command/sale-update-fiscalization-status.command";
import { UpdateAndRecalculatedSalePatternsWithProductCommandHandler } from "./sale/command/update-and-recalculate-sale-patterns-with-product.command";
import { ExistingDocumentsWithNumberQueryHandler } from "./sale/queries/existing-documents-with-number.query";
import { SaleAdvanceHistoryQueryHandler } from "./sale/queries/sale-advance-history.query";
import { SaleAdvancePlainObjectQueryHandler } from "./sale/queries/sale-advance-plain-object.query";
import { AdvanceSummaryQueryHandler } from "./sale/queries/sale-advance-summary.query";
import { SaleCheckCollectiveIdentifierQueryHandler } from "./sale/queries/sale-check-collective-identifier.query";
import { SaleDocumentGetIdByExternalIdQueryHandler } from "./sale/queries/sale-document-get-id-by-external-id.query";
import { SaleDocumentPlainObjectQueryHandler } from "./sale/queries/sale-document-plain-object.query";
import { SaleGetDocumentsToDispatchKsefGridQueryHandler } from "./sale/queries/sale-get-documents-to-dispatch-ksef.query";
import { SaleGridQueryHandler } from "./sale/queries/sale-grid.query";
import { SaleJpkVatGroupCollectionQueryHandlerHandler } from "./sale/queries/sale-jpk-vat-group.query";
import { SaleKindQueryHandler } from "./sale/queries/sale-kind.query";
import { SalePatternGridQueryHandler } from "./sale/queries/sale-pattern-grid.query";
import { SalePatternIssueDocumentQueryHandler, SalePatternIssueMultiDocumentQueryHandler } from "./sale/queries/sale-pattern-issue-document.query";
import { SaleAdvanceAdjustmentRepository } from "./sale/sale-advance-adjustment.repo";
import { SaleAdvanceRepository } from "./sale/sale-advance.repo";
import { SaleDocumentAdjustmentRepository } from "./sale/sale-document-adjustment.repo";
import { SaleDocumentRepository } from "./sale/sale-document.repo";
import { SaleFeatureFlagsRulesService } from "./sale/sale-feature-flags-rules.service";
import { SaleKindRepository } from "./sale/sale-kind.repo";
import { SalePatternRepository } from "./sale/sale-pattern.repo";
import { SaleProFormaRepository } from "./sale/sale-pro-forma.repo";
import { SuzUpdateCredentialsCommandHandler } from "./suz/commands/suz-update-credentials.command";
import { SuzCredentialsQueryHandler } from "./suz/queries/suz-credential.query";
import { SuzFactoryService } from "./suz/suz-factory.service";
import { TaxOfficeQuickListQueryHandler } from "./tax-office/queries/tax-office-quick-list.query";
import { TaxOfficeQueryHandler } from "./tax-office/queries/tax-office.query";
import { TenantAppStateQueryHandler } from "./tenant/tenant-app-state.query";
import { UnitSetDefaultCommandHandler } from "./unit/commands/unit-set-default.command";
import { UnitQueryHandler } from "./unit/queries/unit.query";
import { UnitRepository } from "./unit/unit.repo";
import { SendMultiPaymentReminderQueryHandler, SendPaymentReminderQueryHandler } from "./unsettled-documents/send-payment-reminder.query";
import { UnsettledDocumentsQueryHandler } from "./unsettled-documents/unsettled-documents.query";
import { LoggedUserQueryHandler } from "./user/logged-user.query";
import { UserRoleSynchronizerService } from "./user/user-role-synchronizer.service";
import { UserRoleQueryHandler } from "./user/user-role.query";
import { UserCollectionQueryHandler } from "./user/user.query";
import { UserRepository } from "./user/user.repo";
import { VatRateForPurchaseQueryHandler } from "./vat/queries/vat-rate-for-purchase.query";
import { VatRateForSaleBaseQueryHandler } from "./vat/queries/vat-rate-for-sale-base.query";
import { VatRateForSaleWstoQueryHandler } from "./vat/queries/vat-rate-for-sale-wsto.query";
import { VatRateForSaleQueryHandler } from "./vat/queries/vat-rate-for-sale.query";
import { VatReleaseReasonQueryHandler } from "./vat/queries/vat-release-reason.query";
import { ViewSettingsRepository } from "./view-settings/view-settings.repo";
import { CheckClientBankAccountQueryHandler } from "./white-list/queries/check-client-bank-account.query";
import { SearchClientBankAccountsQueryHandler } from "./white-list/queries/search-client-bank-accounts.query";

export const businessProviders = [
	...OrdersProviders,
	//repositories
    KsefSendParametersRepository,
	IntegrationRepository,
	ImportRepository,
	ProductRepository,
	ClientRepository,
	CurrencyRepository,
	UserRepository,
	CountryRepository,
	ViewSettingsRepository,
	ProductGroupRepository,
	ClientGroupRepository,
	ExpenseRepository,
	CompanyParametersRepository,
	PrintingPatternRepository,
	NumberingRepository,
	UnitRepository,
	FiscalDeviceRepository,
	AdjustmentReasonRepository,
	BankAccountRepository,
	MailTemplateRepository,
	CompanyRepository,
	AccountancyRepository,
	PurchaseExpenseDocumentRepository,
	SalePatternRepository,
	SaleProFormaRepository,
	SaleDocumentRepository,
	SaleAdvanceRepository,
	SaleDocumentAdjustmentRepository,
	SaleAdvanceAdjustmentRepository,
	OssVatRateRepository,
	InventoryGoodsReceiptDocumentRepository,
	InventoryKindRepository,
	InventoryRepository,
	InventoryStocktakingDocumentRepository,
	InventoryGoodsIssueDocumentRepository,
	InventoryDocumentAssociatedWithGoodsIssueQueryHandler,
	InventoryGoodsReceiptAdjustmentDocumentRepository,
	InventoryGoodsIssueAdjustmentDocumentRepository,
	PurchaseInvoiceDocumentRepository,
	PurchaseEInvoiceDocumentRepository,
	PurchaseInvoiceAdjustmentDocumentRepository,

	//query handlers
	SaleCheckCollectiveIdentifierQueryHandler,
	SaleDocumentGetIdByExternalIdQueryHandler,
	ClientGridCollectionQueryHandler,
	CompanyConfigureCommandHandler,
	OrderKindQueryHandler,
	TenantAppStateQueryHandler,
	ProductGetIdsByExternalIdsQueryHandler,
	ProductGroupCollectionQueryHandler,
	ProductOffersQueryHandler,
	ProductJpkVatGroupCollectionQueryHandler,
	CompanyParametersQueryHandler,
	CompanyConfigUrlsQueryHandler,
	CompanyFeaturesQueryHandler,
	ClientGroupCollectionQueryHandler,
	UnitQueryHandler,
	UserLicensesQueryHandler,
	UserRoleSynchronizerService,
	CurrencyCollectionQueryHandler,
	CommunityTransactionForSaleQueryHandler,
	VatRateForSaleQueryHandler,
	PkwiuPagedCollectionQueryHandler,
	ProductGridCollectionQueryHandler,
	ProductsRelatedToSalePatternsQueryHandler,
	ClientQLCollectionQueryHandler,
	GusDataByTinQueryHandler,
	ClientsWithSamePropertyQueryHandler,
	BalanceSheetCollectionQueryHandler,
	BalanceSheetPrintQueryHandler,
	BalanceSheetExportQueryHandler,
	ReportInventoryStocktakingGridQueryHandler,
	ReportInventoryStocktakingPrintQueryHandler,
	ReportInventoryStocktakingExportQueryHandler,
	SalesByClientsCollectionQueryHandler,
	SalesByClientsPrintingQueryHandler,
	SalesByClientsExportQueryHandler,
	UnsettledPaymentsCollectionQueryHandler,
	UnsettledPaymentsExportQueryHandler,
	UnsettledPaymentsPrintingQueryHandler,
	SalesByProductsCollectionQueryHandler,
	SalesByProductsPrintingQueryHandler,
	SalesByProductsExportQueryHandler,
	SalesByPeriodCollectionQueryHandler,
	SalesByPeriodPrintingQueryHandler,
	SalesByPeriodExportQueryHandler,
	IntegrationsListQueryHandler,
	AvailableIntegrationsListQueryHandler,
	SaleRegistryCollectionQueryHandler,
	SaleRegistryExportQueryHandler,
	SaleRegistryPrintingQueryHandler,
	PurchaseRegistryCollectionQueryHandler,
	PurchaseRegistryExportQueryHandler,
	PurchaseRegistryPrintingQueryHandler,
	CountryCollectionQueryHandler,
	ClientsExportQueryHandler,
	ClientsEppExportQueryHandler,
	PaymentMethodQueryHandler,
	PrintingPatternQueryHandler,
	NumberingQueryHandler,
	SaleKindQueryHandler,
	PurchaseKindQueryHandler,
	FiscalDeviceQueryHandler,
	FiscalDeviceRegistryQueryHandler,
	ExpensePagedCollectionQueryHandler,
	AdjustmentReasonQueryHandler,
	BankAccountQueryHandler,
	CheckClientBankAccountQueryHandler,
	SearchClientBankAccountsQueryHandler,
	MailTemplateQueryHandler,
	ExpenseRepository,
	PurchaseKindRepository,
	SaleKindRepository,
	OrderKindRepository,
	MarginSchemeKindQueryHandler,
	VatReleaseReasonQueryHandler,
	TaxOfficeQuickListQueryHandler,
	TaxOfficeQueryHandler,
	CalendarEventsQueryHandler,
	AccountancyEntriesQueryHandler,
	AccountancyGridQueryHandler,
	DateIncludedInAccountingQueryHandler,
	CnCodeQueryHandler,
	ClientLinksQueryHandler,
	CommunityTransactionForPurchaseQueryHandler,
	CurrencyExchangeRateQueryHandler,
	VatRateForPurchaseQueryHandler,
	PurchaseGridQueryHandler,
	PurchaseDocumentUniqueOriginalNumberQueryHandler,
	LoggedUserQueryHandler,
	KsefConfigurationStatusQueryHandler,
	KsefEnvironmentQueryHandler,
	UserCollectionQueryHandler,
	ProductQLCollectionQueryHandler,
	SaleJpkVatGroupCollectionQueryHandlerHandler,
	PurchaseJpkVatGroupCollectionQueryHandler,
	SalePatternGridQueryHandler,
	SalePatternIssueDocumentQueryHandler,
	SalePatternIssueMultiDocumentQueryHandler,
    PurchaseKsefNumberAlreadyInUseQueryHandler,
	SaleDocumentPlainObjectQueryHandler,
	DocumentLinksQueryHandler,
	UnsettledDocumentsQueryHandler,
	SaleAdvancePlainObjectQueryHandler,
	SaleAdvanceHistoryQueryHandler,
	AdvanceSummaryQueryHandler,
	DocumentAdjustmentSummaryQueryHandler,
	SaleGridQueryHandler,
	SendPaymentReminderQueryHandler,
	SendMultiPaymentReminderQueryHandler,
	PurchasesByPeriodCollectionQueryHandler,
	PurchasesByPeriodPrintingQueryHandler,
	PurchasesByPeriodExportQueryHandler,
	AddDashboardNoteCommandHandler,
	UpdateDashboardNoteCommandHandler,
	DeleteDashboardNoteCommandHandler,
	AllDashboardNotesQueryHandler,
	ExistingDocumentsWithNumberQueryHandler,
	VatRateForSaleBaseQueryHandler,
	VatRateForSaleWstoQueryHandler,
	SalesWstoExportQueryHandler,
	SalesWstoCollectionQueryHandler,
	SalesWstoPrintingQueryHandler,
	UpdateAndRecalculatedSalePatternsWithProductCommandHandler,
	EInvoiceReceivedCollectionQueryHandler,
	InventoryLevelGridQueryHandler,
	InventoryStocktakingGridQueryHandler,
	InventoryStocktakingProductRecordsQueryHandler,
	InventoryGoodsIssueGridQueryHandler,
	InventoryGoodsReceiptGridQueryHandler,
	InventoryKindQueryHandler,
	InventoryQueryHandler,
	SaleGetDocumentsToDispatchKsefGridQueryHandler,
	NumberingLinkedWithSalePatternQueryHandler,
	ProductInventoryLevelQueryHandler,
	ProductGeneratingSymbolQueryHandler,
	InventoryMovementReportGridQueryHandler,
	LaboratoryInfoQueryHandler,
	BannerInfoQueryHandler,
	BannerClosedCommandHandler,
	KsefGetDocumentXmlQueryHandler,
	KsefGetDocumentXmlToPreviewQueryHandler,
	KsefGetUpoXmlQueryHandler,
	KsefSentDocumentErrorsQueryHandler,
	EInvoiceReceivedDownloadHeadersLastSuccessDateQueryHandler,
	EInvoiceReceivedGetHeaderXmlQueryHandler,
	EInvoiceReceivedHeaderValidationResultQueryHandler,
	InventoryStocktakingDocumentLinksQueryHandler,
	UserRoleQueryHandler,
	PurchaseEInvoiceGetConvertedXmlQueryHandler,
	ProductsWithSamePropertyQueryHandler,
	SuzCredentialsQueryHandler,
	EInvoiceReceivedGetKsefHashQueryHandler,
	KsefGetHashQueryHandler,
    KsefSendParametersQueryHandler,
    ProductsGetAssociatedEInvoiceSymbolsQueryHandler,
    ProductGetAssociatedEInvoiceSymbolsQueryHandler,
	KsefGetCollectiveIdentifiersByKsefNumberQueryHandler,

	//command handlers
	SaleSaveCollectiveIdentifierCommandHandler,
	EInvoiceReceivedGenerateCollectiveIdentifierHandler,
	FiscalDeviceRegistryCreateEventCommandHandler,
	FiscalDeviceRegistryUpdateEventCommandHandler,
	SuzUpdateCredentialsCommandHandler,
    ProductsAssociateEInvoiceSymbolCommandHandler,
	AccountancySendEmailSingleCommandHandler,
	AccountancySendEmailMultiCommandHandler,
	ProductActivateCommandHandler,
	DocumentDownloadFileCommandHandler,
	DocumentDownloadFileMultiCommandHandler,
	OssVatRateOrderingCommandHandler,
	OssVatRateSetDefaultCommandHandler,
	DocumentSendEmailSingleCommandHandler,
	DocumentSendEmailMultiCommandHandler,
	KsefCheckDocumentStatusCommandHandler,
	KsefReceiveUpoCommandHandler,
	SaleSendDocumentsToKsefCommandHandler,
	ProductEnableInventoryControlCommandHandler,
	FavouriteSwitchCommandHandler,
	LaboratoryRefreshInfoCommandHandler,
	EInvoiceReceivedDownloadHeadersCommandHandler,
	EInvoiceReceivedReceiveXmlCommandHandler,
	EInvoiceReceivedCreateEInvoiceCommandHandler,
	PurchaseExecuteInventoryCostCommandHandler,
	InventoryStocktakingApprovalCommandHandler,
	InventoryStocktakingDownloadDocumentCommandHandler,
	AdjustmentReasonSetDefaultCommandHandler,
	CountrySetDefaultCommandHandler,
	CurrencySetDefaultCommandHandler,
	UnitSetDefaultCommandHandler,
	ProductGroupSetDefaultCommandHandler,
	ClientGroupSetDefaultCommandHandler,
	FiscalDeviceSetDefaultCommandHandler,
	SaleUpdateFiscalizationStatusCommandHandler,
	KsefRefreshConfigurationStatusCommandHandler,

	//others
	PrintingPatternConfig,
	QuickListDataSource,
	QuickListDataSourceFactory,
	CacheableQuickListDataSource,
	ReportExporterService,
	ReportPrinterService,
	OnlineReceiversQueryHandler,
	PaymentMethodBaseQueryHandler,
	PaymentMethodQueryHandler,
	ClientsExportQueryHandler,
	ClientsEppExportQueryHandler,
	ProductsExportQueryHandler,
	ProductsEppExportQueryHandler,
	EventNotificationsService,
	AnnouncementsNotificator,
	DataExchangeStatusNotificator,
	KsefConfigurationStatusNotificator,
	PreparingDataNotificator,
	ClientsImportNotificator,
	ProductsImportNotificator,
	KsefMonitorStatusNotificator,
	SaleStatusesNotificator,
	InventoryStatusesNotificator,
	ReminderStatusesNotificator,
	AccountancyEmailStatusesNotificator,
	AccountancyPeriodDescriptor,
	SaleFeatureFlagsRulesService,
	EmailStatusDescriptorService,
	DocumentKsefStatusNotificator,
	SuzFactoryService,
	KsefCertificateService
];
